import React from "react";
import { PageLayout } from "../components/PageLayout";
import { BuyProduct } from "../features/products/BuyProduct";

export const BuyProductPage: React.FC = () => {
  return <PageLayout>
    <BuyProduct />
  </PageLayout>;
};